/**
 * 聊天未读计数：交流面板没露出来时，攒下新消息条数，
 * 其中有人 @我 的要单独标出来并弹一条提示。
 */

import { useEffect, useRef, useState } from 'react'

import { mentionsMe } from './chatText'
import { useRoomStore } from '../stores/roomStore'

export interface ChatUnread {
  count: number
  /** 未读里有没有 @我 的 */
  mention: boolean
}

export function useChatUnread(visible: boolean): ChatUnread {
  const messages = useRoomStore((s) => s.messages)
  const members = useRoomStore((s) => s.members)
  const selfId = useRoomStore((s) => s.selfId)
  const setToast = useRoomStore((s) => s.setToast)
  const seenRef = useRef(messages.length)
  const [state, setState] = useState<ChatUnread>({ count: 0, mention: false })

  useEffect(() => {
    if (visible) {
      seenRef.current = messages.length
      setState({ count: 0, mention: false })
      return
    }
    // 消息列表被裁到 500 条时长度不会增长，这里按「比上次多出来的」算。
    const fresh = messages.slice(Math.min(seenRef.current, messages.length))
    if (fresh.length === 0) return
    const myName = members.get(selfId)?.name ?? ''
    const names = [...members.values()].map((m) => m.name)
    const hit = fresh.find((m) => m.fromId !== selfId && mentionsMe(m.text, myName, names))
    setState((prev) => {
      const mention = prev.mention || !!hit
      return { count: fresh.length, mention }
    })
    if (hit && !state.mention) {
      const who = hit.name || members.get(hit.fromId)?.name || `席位 ${hit.fromId}`
      setToast(`${who} @了你：${hit.text.slice(0, 40)}`)
    }
  }, [visible, messages, members, selfId])

  return state
}
